import { authHeader, httpHelper } from '../helpers';
import { post } from 'axios';

export const opbcdtService = {
    getOpbSummary,
    findOpbList,
    selectedOpb,
    findOpbContent,
    getRecords,
    setOpbState,
    findOpbGroupPubList,
    publishSend,
    publishPatch,
    getOpbContentsListXls,
};

function getOpbSummary(siteID) {
    const headers = {headers: { ...authHeader(), 'Content-Type': 'application/json' }};
    return post(httpHelper.getApiUrl()+`/opbcdt/summary/${siteID}`, {}, headers);
}

function findOpbList(formData) {
    const headers = {headers: { ...authHeader(), 'Content-Type': 'application/json' }};
    return post(httpHelper.getApiUrl()+`/opbcdt/list`, formData, headers);
}

function selectedOpb(formData) {
    const headers = {headers: { ...authHeader(), 'Content-Type': 'application/json' }};
    return post(httpHelper.getApiUrl()+`/opbcdt/select`, formData, headers);
}

function findOpbContent(formData) {
    const headers = {headers: { ...authHeader(), 'Content-Type': 'application/json' }};
    return post(httpHelper.getApiUrl()+`/opbcdt/findOpbContent`, formData, headers);
}

function getRecords(formData) {
    const headers = {headers: { ...authHeader(), 'Content-Type': 'application/json' }};
    return post(httpHelper.getApiUrl()+`/opbcdt/record`, formData, headers);
}
function setOpbState(raw) {
    const headers = {headers: { ...authHeader(), 'Content-Type': 'application/json' }};
    return post(httpHelper.getApiUrl()+`/opbcdt/add`, raw, headers);
}

function findOpbGroupPubList(formData) {
    const headers = {headers: { ...authHeader(), 'Content-Type': 'application/json' }};
    return post(httpHelper.getApiUrl()+`/opbcdt/findOpbGroupPubList`, formData, headers);
}

function publishSend(formData) {
    const headers = {headers: { ...authHeader(), 'Content-Type': 'application/json' }};
    return post(httpHelper.getApiUrl()+`/publish/send`, formData, headers);
}

function publishPatch(formData) {
    const headers = {headers: { ...authHeader(), 'Content-Type': 'application/json' }};
    return post(httpHelper.getApiUrl()+`/publish/patch`, formData, headers);
}

function getOpbContentsListXls(formData) {
    const headers = {headers: authHeader(), responseType: 'blob'};
    return post(httpHelper.getApiUrl()+`/opbcdt/opbContentsListXls`, formData, headers);
}